module.exports = __webpack_public_path__ + "img/galleria15.d39e593a.jpg";